module.exports = __webpack_public_path__ + "static/media/KWU.33593f9e.png";